import * as rmd from 'material-ui';
import React from 'react';
import config from 'cfg';
import Promise from 'bluebird';
import moment from 'moment';
import _ from 'lodash';

class DatePickerBySport extends React.Component {
    constructor(props, context) {
        super(props, context);
        console.log(props);
        this.state = {
            date: props.date ? new Date(props.date) : new Date(),
            disabledPickerValue: true,
            sport: props.sport || props.defaultSportValue
        };
    }

    componentDidMount() {
        this.handleDateChange(null, this.state.date);
    }

    handleDateChange = (key, value) => {
        var date = moment(value).local();
        var from = date.format('YYYY-MM-DD');
        this.setState({ date: value });
        this.props.onChange('date', from);
    };

    handleChange = (event, index, value) => {
        this.setState({
            sport: value,
            disabledPickerValue: value !== _.head(this.props.sports)
        });

        this.props.onChange('sport', value);
    };

    render() {
        return (
            <div>
                <rmd.SelectField
                    floatingLabelText="Sport"
                    style={{ overflow: 'hidden', width: '100%' }}
                    value={this.state.sport}
                    disabled={!this.state.date}
                    autoWidth
                    onChange={this.handleChange}
                >
                    {this.props.sports.map((sport, i) => {
                        return <rmd.MenuItem style={{ minWidth: '400px' }} key={i} value={sport} primaryText={sport} />;
                    })}
                </rmd.SelectField>

                {!this.state.disabledPickerValue && (
                    <rmd.DatePicker
                        hintText="Choose date"
                        style={{ overflow: 'hidden', width: '100%' }}
                        floatingLabelText="Date (when all sports)"
                        value={this.state.date}
                        container="dialog"
                        autoOk
                        onChange={this.handleDateChange}
                    />
                )}
            </div>
        );
    }
}

export default DatePickerBySport;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/SportByDatePicker.js
 **/